import { http } from '@/http'

export default {
  list()           { return http.get('/legal-parameters') },
  get(id)          { return http.get(`/legal-parameters/${id}`) },
  getByYear(year)  { return http.get(`/legal-parameters/year/${year}`) },
  getLatest()      { return http.get('/legal-parameters/latest') },
  save(data)       { return http.post('/legal-parameters', data) },
  update(id, data) { return http.put(`/legal-parameters/${id}`, data) },
}
